import { Divider, List, ListItem } from '@mui/material'
import { Fragment, type FC } from 'react'

import { DestinationLoading } from './common'

export const ContextMenuDestinationsLoading: FC = () => {
  return (
    <List disablePadding>
      {Array.from({ length: 3 }).map((_, index) => (
        <Fragment key={index}>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <DestinationLoading />
          </ListItem>
          {index < 2 && <Divider component='li' />}
        </Fragment>
      ))}
    </List>
  )
}
